import { removeWallet } from 'reduxState/wallet/walletReducer';

import { setDelegatedKey } from './authorizationReducer';

import type { Reducer } from 'redux';

export type DelegatedStorageEngine = 'persistent' | 'session';

/** Warning: This might be cached in LocalStorage - be careful with changing */
export type DelegatedKeySettings = {
  engine?: DelegatedStorageEngine;
};

const defaultState: DelegatedKeySettings = {
  engine: undefined,
};

// Actions

type Actions = ReturnType<typeof setDelegatedKey | typeof removeWallet>;

// Reducer @cached

export const delegatedKeySettingsReducer: Reducer<
  DelegatedKeySettings,
  Actions
> = (state = defaultState, action): DelegatedKeySettings => {
  switch (action.type) {
    case 'SET_DELEGATED_KEY':
      return {
        engine: action.storageEngine,
      };
    case 'REMOVE_WALLET':
      return {
        engine: undefined,
      };
    default:
      return state;
  }
};
